<template>
    <nav class="navbar body navbar-expand-lg sticky-top bodyy" style="direction: rtl;">
    <div class="container">

        <!-- Top Row (ALWAYS one line) -->
        <div class="d-flex align-items-center justify-content-between w-100">

        <!-- RIGHT SIDE (Brand / Back / User) -->
        <div class="d-flex align-items-center">

            <!-- Back Button -->
            <button
            v-if="showBackButton"
            @click="goBack"
            class="btn-back ms-2"
            :title="$t('back')">
            →
            </button>
            <!-- <NotificationBell @notify="onNotify" /> -->

            <!-- Logo -->
            <div v-if="!isAuthenticated" class="d-flex align-items-center">

                <button
                    class="navbar-toggler ms-2"
                    style="background-color: var(--drop-down);"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav">

                    <span class="navbar-toggler-icon"></span>

                </button>

            <span class="navbar-brand mb-0">
                <a style="text-decoration: none; color: var(--text);" href="/">{{ $t('brand') }}</a>
            </span>

            </div>

            <!-- Role Switcher -->
            <!--
            <div v-if="showRoleSwitcher" class="ms-3">
            <RoleSwitcher />
            </div>
            -->
            

            <!-- User Dropdown -->
            <div v-if="isAuthenticated" class="dropdown user-dropdown ms-3">

            <a class="nav-link dropdown-toggle d-flex align-items-center"
                href="#"
                data-bs-toggle="dropdown">

                <span class="user-avatar ms-2">
                {{ userInitial }}
                </span>

            </a>

            <ul class="dropdown-menu dropdown-menu-start">

                <li>
                <span style="color: var(--text);" class="dropdown-item-text fw-bold">
                    {{ userFirstName }}
                </span>
                </li>

                <li><hr class="dropdown-divider"></li>

                <li>
                <a style="color: var(--text);" class="dropdown-item" href="#" @click.prevent="openProfileModal">
                    <i class="bi bi-person ms-2"></i>
                    {{ $t('profile') }}
                </a>
                </li>

                <!--<li>
                    <a style="color: var(--text);" class="dropdown-item" href="#" @click.prevent="goToDriverRegisteration">
                        <i class="bi bi-person ms-2"></i>
                        {{ $t('profileDriver') }}
                    </a>
                </li>-->
                <li><hr class="dropdown-divider"></li>

                <li>
                <a class="dropdown-item text-danger" href="#" @click.prevent="handleLogout">
                    <i class="bi bi-box-arrow-right ms-2"></i>
                    {{ $t('logout') }}
                </a>
                </li>

            </ul>
            </div>

        </div>


        <!-- LEFT SIDE CONTROLS -->
        <div class="d-flex align-items-center flex-nowrap nav-controls">

            <!-- Theme -->
            <button class="btn btn-sm ms-2" @click="toggleTheme">
            {{ currentTheme === 'dark' ? '☀️' : '🌙' }}
            </button>

            <!-- Language -->
            <select class="language-switch form-select form-select-sm ms-2"
                    v-model="currentLang"
                    @change="changeLanguage(currentLang)"
                    style="width:110px">
            <option class="option" value="fa">فارسی</option>
            <option class="option" value="en">EN</option>
            <option class="option" value="ar">العربية</option>
            </select>

            <!-- Mobile Menu Button -->
            

        </div>

        </div>


        <!-- Collapsible Menu -->
        <div class="collapse navbar-collapse mt-3" id="navbarNav">

        <ul class="navbar-nav ms-auto">

            <li class="nav-item">
            <a class="nav-link" href="#about">
                {{ $t('about') }}
            </a>
            </li>

            <template v-if="!isAuthenticated">

            <li class="nav-item">
                <a class="nav-link" href="/login">
                {{ $t('login') }}
                </a>
            </li>

            <li class="nav-item">
                <a class="nav-link btn-register px-3" href="/register">
                {{ $t('signup') }}
                </a>
            </li>

            </template>

        </ul>

        </div>

    </div>
    </nav>

    <!-- Bottom Navbar Section -->
    <div 
        v-if="isAuthenticated && selectedCompany"
        class="sticky-company-bar"
    >
    
        <!-- Right side: company name -->
        <div class="company-bar-company">
            <i class="bi bi-building ms-1"></i>
            <span>{{ selectedCompany.company_name }}</span>
        </div>

        <!-- Left side: database selector -->
        <div 
            v-if="companyDatabases && companyDatabases.length > 1"
            class="company-bar-db"
        >
            <select
                class="db-switch-select"
                v-model="selectedDb"
                :disabled="switchingDatabase"
                @change="handleDatabaseChange"
            >
                <option
                    v-for="db in companyDatabases"
                    :key="db.key"
                    :value="db.key"
                >
                    {{ db.label || db.name }}
                </option>
            </select>
        </div>

        <!-- If only one DB exists, show name instead of select -->
        <div 
            v-else-if="companyDatabases && companyDatabases.length === 1"
            class="company-bar-db single-db"
        >
            {{ companyDatabases[0].label || companyDatabases[0].name }}
        </div>
    </div>

    <!-- PROFILE MODAL -->
    <div v-if="showProfileModal" class="body profile-modal-overlay">
    <div class="profile-modal">

        <div class="pm-header">
        <h3>{{ $t("navbar.profile.title") }}</h3>
        <button class="pm-close" @click="closeProfileModal">✕</button>
        </div>

        <div class="pm-body">

        <div class="pm-avatar">
            {{ userInitial }}
        </div>

        <!-- FIRST NAME -->
        <div class="pm-group">
            <label class="pm-label">{{ $t("navbar.profile.firstName") }}</label>
            <input v-model="profileData.first_name" class="pm-input" :placeholder="$t('navbar.profile.firstName')" />
        </div>

        <!-- LAST NAME -->
        <div class="pm-group">
            <label class="pm-label">{{ $t("navbar.profile.lastName") }}</label>
            <input v-model="profileData.last_name" class="pm-input" :placeholder="$t('navbar.profile.lastName')" />
        </div>

        <!-- EMAIL -->
        <div class="pm-group">
            <label class="pm-label">{{ $t("navbar.profile.email") }}</label>
            <input v-model="profileData.email" class="pm-input" :placeholder="$t('navbar.profile.email')" />
        </div>

        <!-- PHONE (READ ONLY) -->
        <div class="pm-group">
            <label class="pm-label">{{ $t("navbar.profile.phone") }}</label>
            <input class="pm-input" v-model="profileData.phone_number" disabled />
        </div>

        </div>

        <div class="pm-footer">

        <button class="pm-btn secondary" @click="closeProfileModal">
            {{ $t("navbar.profile.cancel") }}
        </button>

        <button class="pm-btn primary"
                :disabled="!hasChanges || updatingProfile"
                @click="updateProfile">

            <span v-if="!updatingProfile">{{ $t("navbar.profile.save") }}</span>
            <span v-else class="pm-spinner"></span>

        </button>

        </div>

    </div>
    </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth'
import { computed, onMounted, ref, watch, onBeforeUnmount } from 'vue'
import { profileService, cancelAllRequests, getActiveRequestCount } from '@/services/api'
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router'
import RoleSwitcher from '@/components/RoleSwitcher.vue'
import NotificationBell from './NotificationBell.vue'
import { useI18n } from 'vue-i18n'

export default {
    name: 'AppNavbar',
    components: {
        RoleSwitcher,
        NotificationBell
    },
    props: {
        // Prop to control back button visibility
        showBackButton: {
            type: Boolean,
            default: false
        },
        // Prop for custom back route
        backRoute: {
            type: [String, Object],
            default: null
        },
        // Prop for back button title/tooltip
        backButtonTitle: {
            type: String,
            default: 'بازگشت'
        },
        // Prop for custom back function
        customBackFunction: {
            type: Function,
            default: null
        }
    },
    emits: ['back'],
    setup(props, { emit }) {
        const { locale } = useI18n()
        const route = useRoute()
        const router = useRouter()
        const authStore = useAuthStore()

        // ============= STATE =============
        const currentTheme = ref(localStorage.getItem("theme") || "light")
        const currentLang = ref(localStorage.getItem("lang") || "fa")
        const showProfileModal = ref(false)
        const updatingProfile = ref(false)
        const isMounted = ref(true)
        const selectedDb = ref(authStore.activeDatabase || 'db1')
        
        // Original profile data for comparison
        const originalProfileData = ref({})
        const profileData = ref({
            customer_id: '',
            first_name: '',
            last_name: '',
            email: '',
            phone_number: ''
        })

        // ============= COMPUTED =============
        const isAuthenticated = computed(() => authStore.isAuthenticated)
        const user = computed(() => authStore.user)
        
        const userFirstName = computed(() => {
            if (authStore.user?.first_name) {
                return authStore.user.first_name
            }
            if (authStore.user?.name) {
                return authStore.user.name
            }
            if (authStore.user?.phone) {
                return authStore.user.phone
            }
            return 'User'
        })
        
        const userInitial = computed(() => {
            if (authStore.user?.first_name) {
                return authStore.user.first_name.charAt(0).toUpperCase()
            }
            if (authStore.user?.name) {
                return authStore.user.name.charAt(0).toUpperCase()
            }
            if (authStore.user?.phone) {
                return authStore.user.phone.charAt(0)
            }
            return 'U'
        })

        // Check if there are any changes
        const hasChanges = computed(() => {
            return JSON.stringify(profileData.value) !== JSON.stringify(originalProfileData.value)
        })

        const selectedCompany = computed(() => authStore.selectedCompany)
        const companyDatabases = computed(() => authStore.companyDatabases)
        const activeDatabase = computed(() => authStore.activeDatabase)
        const switchingDatabase = computed(() => authStore.switchingDatabase)

        const showRoleSwitcher = computed(() => {
            if (route.path === '/') return false
            if (route.path.startsWith('/company/')) return false
            return authStore.isAuthenticated && authStore.hasMultipleRoles
        })      
        
        const showDropUser = computed(() => {
            if (route.path === '/') return false
            return authStore.isAuthenticated && authStore.hasMultipleRoles
        })  

        // ============= ABORT CONTROLLER CLEANUP =============
        
        // Cancel all pending requests on component unmount
        onBeforeUnmount(() => {
            isMounted.value = false
            console.log('Navbar unmounting, cancelling requests...')
            const activeCount = getActiveRequestCount()
            if (activeCount > 0) {
                cancelAllRequests()
            }
        })

        // Cancel requests when route changes (navigation)
        onBeforeRouteLeave((to, from, next) => {
            const activeCount = getActiveRequestCount()
            if (activeCount > 0) {
                console.log(`Navigating away from ${from.path} with ${activeCount} active requests, cancelling...`)
                cancelAllRequests()
            }
            // Give a small delay for cancellation to complete
            setTimeout(() => {
                next()
            }, 50)
        })

        // ============= EVENT HANDLERS =============
        
        // Handle page refresh/unload
        const handleBeforeUnload = () => {
            console.log('Page refreshing, cancelling all requests...')
            cancelAllRequests()
        }

        // Handle visibility change (tab switch)
        const handleVisibilityChange = () => {
            if (document.hidden) {
                console.log('Tab hidden, cancelling requests...')
                // Optional: Cancel requests when tab is hidden
                // cancelAllRequests()
            }
        }

        // Close modal when clicking outside
        const handleOutsideClick = (event) => {
            if (showProfileModal.value && event.target.classList.contains('profile-modal-overlay')) {
                closeProfileModal()
            }
        }

        // ============= NAVIGATION METHODS =============

        // Go back method with request cancellation
        const goBack = async () => {
            // Cancel frontend requests
            const activeCount = getActiveRequestCount()
            if (activeCount > 0) {
                console.log(`Going back with ${activeCount} active requests, cancelling...`)
                cancelAllRequests()
            }
            
            // Emit back event first (for parent components to handle)
            emit('back')
        }

        // Navigate with request cancellation
        const navigateTo = (path) => {
            const activeCount = getActiveRequestCount()
            if (activeCount > 0) {
                console.log(`Navigating to ${path} with ${activeCount} active requests, cancelling...`)
                cancelAllRequests()
            }
            
            // Small delay to allow cancellation
            setTimeout(() => {
                router.push(path)
            }, 50)
        }

        const goToLanding = () => {
            navigateTo('/')
        }

        const goToDriverRegisteration = () => {
            navigateTo('/peak/register-driver')
        }

        // ============= PROFILE METHODS =============

        const openProfileModal = async () => {
            try {
                // Load fresh customer data from backend
                const response = await profileService.getCustomerProfile()
                console.log('Customer profile response:', response.data)
                
                const customerData = response.data.customer_data
                
                // Set profile data with correct field names for backend
                profileData.value = {
                    customer_id: customerData.id,
                    first_name: customerData.first_name || '',
                    last_name: customerData.last_name || '',
                    email: customerData.email || '',
                    phone_number: customerData.phone_number || ''
                }
                
                // Also update the auth store with fresh data
                if (authStore.user) {
                    authStore.user.first_name = customerData.first_name
                    authStore.user.last_name = customerData.last_name
                    authStore.user.email = customerData.email
                    authStore.user.name = `${customerData.first_name || ''} ${customerData.last_name || ''}`.trim() || customerData.phone_number
                    // Update localStorage
                    localStorage.setItem('user', JSON.stringify(authStore.user))
                }
                
                // Store original data for comparison
                originalProfileData.value = { ...profileData.value }
                
                showProfileModal.value = true
                
            } catch (error) {
                console.error('Error loading profile:', error)
                
                // Check if request was cancelled
                if (error.cancelled) {
                    console.log('Profile request was cancelled')
                    return
                }
                
                // Fallback to stored user data
                if (authStore.user) {
                    profileData.value = {
                        customer_id: authStore.user.id || authStore.user.customer_id,
                        first_name: authStore.user.first_name || '',
                        last_name: authStore.user.last_name || '',
                        email: authStore.user.email || '',
                        phone_number: authStore.user.phone || authStore.user.phone_number || ''
                    }
                    originalProfileData.value = { ...profileData.value }
                    showProfileModal.value = true
                } else {
                    alert('خطا در بارگذاری پروفایل. لطفاً دوباره تلاش کنید.')
                }
            }
        }

        const closeProfileModal = () => {
            showProfileModal.value = false
            // Reset form data
            profileData.value = { ...originalProfileData.value }
        }

        const updateProfile = async () => {
            if (!profileData.value.customer_id) {
                alert('خطا: شناسه کاربر یافت نشد')
                return
            }

            if (!hasChanges.value) {
                alert('هیچ تغییری اعمال نشده است')
                return
            }

            updatingProfile.value = true
            try {
                // Prepare data for backend (only send changed fields)
                const updateData = {
                    customer_id: parseInt(profileData.value.customer_id) // Ensure it's a number
                }

                let hasUpdateFields = false

                // Only include fields that have changed and are not empty
                if (profileData.value.first_name !== originalProfileData.value.first_name) {
                    updateData.first_name = profileData.value.first_name || ''
                    hasUpdateFields = true
                }
                if (profileData.value.last_name !== originalProfileData.value.last_name) {
                    updateData.last_name = profileData.value.last_name || ''
                    hasUpdateFields = true
                }
                if (profileData.value.email !== originalProfileData.value.email) {
                    updateData.email = profileData.value.email || ''
                    hasUpdateFields = true
                }

                // Check if we actually have fields to update
                if (!hasUpdateFields) {
                    alert('هیچ فیلدی برای به‌روزرسانی وجود ندارد')
                    updatingProfile.value = false
                    return
                }

                console.log('Sending update data:', updateData)

                // Call backend update endpoint
                const response = await profileService.updateProfile(updateData)
                console.log('Update response:', response.data)

                if (response.data.success) {
                    // Update local user data in auth store with response data
                    if (authStore.user && response.data.customer) {
                        const updatedCustomer = response.data.customer
                        authStore.user.first_name = updatedCustomer.first_name
                        authStore.user.last_name = updatedCustomer.last_name
                        authStore.user.email = updatedCustomer.email
                        authStore.user.name = `${updatedCustomer.first_name || ''} ${updatedCustomer.last_name || ''}`.trim() || authStore.user.phone
                        
                        // Update localStorage
                        localStorage.setItem('user', JSON.stringify(authStore.user))
                    }

                    // Update original data
                    originalProfileData.value = { ...profileData.value }
                    
                    // Show success message
                    alert('پروفایل با موفقیت به‌روزرسانی شد!')
                    
                    // Close modal after short delay
                    setTimeout(() => {
                        showProfileModal.value = false
                    }, 1000)
                } else {
                    throw new Error(response.data.message || 'Update failed')
                }
                
            } catch (error) {
                console.error('Error updating profile:', error)
                let errorMessage = 'خطا در به‌روزرسانی پروفایل. لطفاً دوباره تلاش کنید.'
                
                if (error.response?.data?.detail) {
                    errorMessage = error.response.data.detail
                } else if (error.message) {
                    errorMessage = error.message
                }
                
                alert(errorMessage)
                
                // Reload original data on error
                profileData.value = { ...originalProfileData.value }
            } finally {
                updatingProfile.value = false
            }
        }

        // ============= THEME & LANGUAGE =============

        const toggleTheme = () => {
            currentTheme.value = currentTheme.value === "light" ? "dark" : "light"
            document.documentElement.setAttribute("data-theme", currentTheme.value)
            localStorage.setItem("theme", currentTheme.value)
        }

        const changeLanguage = (lang) => {
            locale.value = lang
            currentLang.value = lang
            localStorage.setItem("lang", lang)
            // Update document direction
            if (lang === "fa" || lang === "ar") {
                document.documentElement.dir = "rtl"
            } else {
                document.documentElement.dir = "ltr"
            }
        }

        // ============= DATABASE SWITCH =============

        const handleDatabaseChange = async () => {
            const oldDb = authStore.activeDatabase

            try {
                await authStore.switchDatabase(selectedDb.value)
                // Reload current page because all existing API calls should now use new DB
                window.location.reload()
            } catch (error) {
                selectedDb.value = oldDb || 'db1'
            }
        }

        // ============= LOGOUT =============

        const handleLogout = async () => {
            try {
                // Cancel all pending requests on logout
                cancelAllRequests()
                await authStore.logout()
                window.location.href = '/'
            } catch (error) {
                console.error('Logout error:', error)
            }
        }

        // ============= WATCHERS =============

        watch(() => route.path, () => {
            console.log('Route changed, role switcher visibility:', showRoleSwitcher.value)
        })

        watch(activeDatabase, (newValue) => {
            selectedDb.value = newValue || 'db1'
        })

        // ============= LIFECYCLE =============

        onMounted(async () => {
            // Keep the document theme synchronized when an auth page uses the
            // legacy navbar. Without this, the page can remain in the default
            // light tokens until the toggle is clicked for the first time.
            document.documentElement.setAttribute('data-theme', currentTheme.value)

            // Register event listeners
            window.addEventListener('beforeunload', handleBeforeUnload)
            document.addEventListener('visibilitychange', handleVisibilityChange)
            document.addEventListener('click', handleOutsideClick)
            
            // Restore mounted state
            isMounted.value = true

            // Check authentication
            if (authStore.token) {
                await authStore.checkAuth()

                if (authStore.selectedCompany) {
                    try {
                        const result = await authStore.fetchCompanyDatabases()
                        console.log('Company databases:', result)
                        companyDatabases.value = authStore.companyDatabases
                        selectedDb.value = authStore.activeDatabase || 'db1'
                    } catch (error) {
                        console.error('Could not load company databases:', error)
                    }
                }
            }
        })

        // Clean up event listeners on unmount
        onBeforeUnmount(() => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
            document.removeEventListener('visibilitychange', handleVisibilityChange)
            document.removeEventListener('click', handleOutsideClick)
        })

        // ============= RETURN =============

        return {
            // State
            isAuthenticated,
            user,
            userFirstName,
            userInitial,
            showProfileModal,
            profileData,
            updatingProfile,
            hasChanges,
            showRoleSwitcher,
            showDropUser,
            selectedCompany,
            companyDatabases,
            activeDatabase,
            selectedDb,
            switchingDatabase,
            currentTheme,
            currentLang,
            
            // Methods
            openProfileModal,
            closeProfileModal,
            updateProfile,
            handleLogout,
            goToDriverRegisteration,
            goToLanding,
            goBack,
            navigateTo,
            toggleTheme,
            changeLanguage,
            handleDatabaseChange,
        }
    },
    mounted() {
        this.initializeNavbarToggler()
    },
    methods: {
        initializeNavbarToggler() {
            const navbarToggler = document.getElementById('navbarToggler');
            const navbarNav = document.getElementById('navbarNav');
            
            if (navbarToggler && navbarNav) {
                // Initialize navbar state
                navbarToggler.setAttribute('aria-expanded', 'false');
                navbarNav.classList.remove('show');
                
                navbarToggler.addEventListener('click', function() {
                    const isExpanded = navbarToggler.getAttribute('aria-expanded') === 'true';
                    navbarNav.classList.toggle('show');
                    navbarToggler.setAttribute('aria-expanded', !isExpanded);
                });

                // Close navbar when clicking on a link (mobile)
                const navLinks = navbarNav.querySelectorAll('.nav-link:not(.dropdown-toggle)');
                navLinks.forEach(link => {
                    link.addEventListener('click', function() {
                        if (window.innerWidth < 992) {
                            navbarNav.classList.remove('show');
                            navbarToggler.setAttribute('aria-expanded', 'false');
                        }
                    });
                });

                // Close navbar when clicking outside (mobile) - EXCLUDE dropdowns
                document.addEventListener('click', function(event) {
                    if (window.innerWidth < 992 && 
                        !navbarToggler.contains(event.target) && 
                        !navbarNav.contains(event.target) &&
                        navbarNav.classList.contains('show')) {
                        navbarNav.classList.remove('show');
                        navbarToggler.setAttribute('aria-expanded', 'false');
                    }
                });

                // Handle window resize
                window.addEventListener('resize', function() {
                    if (window.innerWidth >= 992) {
                        navbarNav.classList.add('show');
                        navbarToggler.setAttribute('aria-expanded', 'true');
                    } else {
                        if (!navbarNav.classList.contains('show')) {
                            navbarToggler.setAttribute('aria-expanded', 'false');
                        }
                    }
                });

                // Initialize based on current screen size
                if (window.innerWidth >= 992) {
                    navbarNav.classList.add('show');
                    navbarToggler.setAttribute('aria-expanded', 'true');
                }
            }
        }
    }
}
</script>

<style scoped>
    .navbar {
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
    }

    .navbar-brand {
        font-weight: bold;
        color: #001e52 !important;
    }

    .nav-link {
        color: #001e52 !important;
        font-weight: 500;
        transition: all 0.3s ease;
    }

    .nav-link:hover {
        color: rgba(0, 30, 82, 0.8) !important;
    }

    .user-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background-color: #2563eb;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 14px;
    }

    .dropdown-menu {
        border: none;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
    }

    .dropdown-item {
        padding: 0.5rem 1rem;
        transition: all 0.2s ease;
    }

    .dropdown-item:hover {
        background-color: #f8f9fa;
    }

    /* Custom navbar styles */
    .navbar-collapse {
        transition: all 0.35s ease-in-out;
    }

    .navbar-collapse:not(.show) {
        display: none;
    }

    .navbar-collapse.show {
        display: block;
    }

    .navbar-collapse.collapsing {
        height: 0;
        overflow: hidden;
        transition: height 0.35s ease;
    }

    /* Mobile styles */
    @media (max-width: 991.98px) {
        .navbar-collapse {
            position: absolute;
            top: 100%;
            left: 0;
            right: 0;
            background: white;
            z-index: 1000;
            padding: 1rem;
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
            border-radius: 0.375rem;
            margin: 0.5rem;
        }
        
        .navbar-nav {
            text-align: center;
        }
        
        .navbar-nav .nav-item {
            margin-bottom: 0.5rem;
            
        }
        
        .navbar-nav .nav-item:last-child {
            margin-bottom: 0;
        }
        
        .navbar-nav .btn {
            display: block;
            width: 100%;
            text-align: center;
        }
        
        /* Ensure navbar starts collapsed on mobile */
        .navbar-collapse:not(.show) {
            display: none !important;
        }

        .dropdown-menu {
            text-align: center;
            border: 1px solid #eee;
        }
    }

    /* Desktop styles */
    @media (min-width: 992px) {
        .navbar-toggler {
            display: none;
        }
        
        .navbar-collapse {
            display: flex !important;
        }
        
        /* Ensure navbar is always visible on desktop */
        .navbar-collapse:not(.show) {
            display: flex !important;
        }
    }

    .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(255, 255, 255);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
    padding: 1rem;
    }

    .modal-content {
        padding: 10px;
    background-color: rgb(255, 255, 255);
    border-radius: 16px;
    width: 100%;
    max-width: 500px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    z-index: 9999;
    }

    .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 1.5rem 1rem;
    border-bottom: 1px solid #e0e0e0;
    }

    .modal-header h3 {
    margin: 0;
    color: #333;
    font-size: 1.25rem;
    }

    .close-btn {
    background: none;
    border: none;
    color: #666;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    min-height: 44px;
    }

    .close-btn:hover {
    background: #f8f9fa;
    }

    .modal-body {
    padding: 1rem 1.5rem;
    }

    .form-group {
    margin-bottom: 1.5rem;
    }

    .form-label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #333;
    }

    .form-input {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 1rem;
    transition: border-color 0.3s ease;
    }

    .form-input:focus {
    outline: none;
    border-color: #4285f4;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
    }

    .form-input:read-only {
    background-color: #f8f9fa;
    color: #666;
    }

    .form-text {
    display: block;
    margin-top: 0.25rem;
    color: #666;
    font-size: 0.875rem;
    }

    .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    padding: 1rem 1.5rem;
    border-top: 1px solid #e0e0e0;
    }

    .btn-secondary, .btn-primary {
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    min-height: 44px;
    }

    .btn-secondary {
    background: #f8f9fa;
    color: #333;
    }

    .btn-secondary:hover {
    background: #e8eaed;
    }

    .spinner {
    width: 16px;
    height: 16px;
    border: 2px solid transparent;
    border-top: 2px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    display: inline-block;
    }

    @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
    }

    /* Mobile Responsive */
    @media (max-width: 768px) {

    .modal-overlay {
        padding: 0.5rem;
        align-items: flex-end;
    }
    
    .modal-content {
        max-height: 85vh;
        border-radius: 16px 16px 0 0;
    }
    
    .modal-header {
        padding: 1.25rem 1.25rem 1rem;
    }
    
    .modal-body {
        padding: 0.75rem 1.25rem;
    }
    
    .modal-footer {
        flex-direction: column-reverse;
        gap: 0.75rem;
    }
    
    .btn-secondary, .btn-primary {
        width: 100%;
    }
    }

    .form-input {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 1rem;
    transition: border-color 0.3s ease;
    background-color: white;
}

.form-input:focus {
    outline: none;
    border-color: #4285f4;
    box-shadow: 0 0 0 3px rgba(66, 133, 244, 0.1);
}

/* Style specifically for select elements */
select.form-input {
    appearance: none;
    background-image: url("data:image/svg+xml;charset=US-ASCII,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'><path fill='%23666' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 0.65rem;
    padding-right: 2.5rem;
}
.user-avatar {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    border: 2px solid #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.profile-avatar-large {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 32px;
    border: 4px solid #fff;
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

/* Modal Styles */
.modal-content {
    border: none;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.modal-header {
    border-radius: 12px 12px 0 0;
    border-bottom: 1px solid #dee2e6;
}

.modal-body {
    padding: 2rem;
}

/* Form Styles */
.form-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.5rem;
}

.form-control {
    border: 1px solid #ced4da;
    border-radius: 8px;
    padding: 0.75rem 1rem;
    transition: all 0.3s ease;
}

.form-control:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.form-control:disabled {
    background-color: #f8f9fa;
    color: #6c757d;
}

/* Button Styles */
.btn {
    border-radius: 8px;
    padding: 0.75rem 1.5rem;
    font-weight: 600;
    transition: all 0.3s ease;
}

.btn-primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
}

.btn-register {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 8px;
}

.btn-primary:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-outline-secondary:hover:not(:disabled) {
    transform: translateY(-2px);
}

/* Dropdown Styles */
.user-dropdown .dropdown-menu {
    border: none;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    margin-top: 10px;
}

.user-dropdown .dropdown-item {
    padding: 0.75rem 1rem;
    border-radius: 6px;
    margin: 0.1rem 0.5rem;
    width: auto;
}

.user-dropdown .dropdown-item:hover {
    background-color: #f8f9fa;
}

/* Responsive Design */
@media (max-width: 768px) {
    .modal-dialog {
        margin: 1rem;
    }
    
    .modal-body {
        padding: 1.5rem;
    }
    
    .profile-avatar-large {
        width: 60px;
        height: 60px;
        font-size: 24px;
    }
}

/* Animation for modal */
.modal.fade.show {
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

/* Navbar specific styles */
.navbar-brand {
    font-weight: 700;
    color: #2c3e50;
}

.nav-link {
    font-weight: 500;
    color: #495057;
    transition: color 0.3s ease;
}

.nav-link:hover {
    color: #667eea;
}

.bodyy {
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.logo-icon img {
  max-width: 80%; /* Limit image to 70% of container */
  max-height: 80%; /* Limit image to 70% of container */
  object-fit: contain; /* Maintain aspect ratio */
}
.logo-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a6baf;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  overflow: hidden; /* Prevent image overflow */
}

.user-dropdown {
    position: relative;
}

.user-dropdown .dropdown-menu {
    right: 0 !important;
    left: auto !important;
    transform: translateX(0) !important;
}

/* For Bootstrap 5 RTL support */
[dir="rtl"] .dropdown-menu-end {
    --bs-position: start;
    right: auto !important;
    left: 0 !important;
}

[dir="rtl"] .dropdown-menu-start {
    --bs-position: end;
    right: 0 !important;
    left: auto !important;
}

/* Fix icon spacing for RTL */
.dropdown-item i {
    margin-left: 0.5rem;
    margin-right: 0;
}

/* Ensure dropdown aligns properly under the avatar */
.user-dropdown .dropdown-toggle::after {
    margin-right: 0.5rem;
    margin-left: 0;
}

/* Mobile responsive fix */
@media (max-width: 991.98px) {
    .user-dropdown .dropdown-menu {
        right: auto !important;
        left: 50% !important;
    }
    
    /* Center dropdown on mobile */
    .user-dropdown .dropdown-menu {
        position: absolute !important;
        right: 0 !important;
        left: 0 !important;
        transform: translateX(30%) !important;
    }
}

.navbar-toggler {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.navbar-toggler:focus {
    box-shadow: none;
    outline: none;
}

/* Fix for mobile alignment */
@media (max-width: 991.98px) {
    .navbar .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .navbar .d-flex.align-items-center {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    /* Ensure the toggler and brand are on the same line */
    .d-flex.align-items-center .navbar-toggler,
    .d-flex.align-items-center .navbar-brand {
        display: inline-flex;
        align-items: center;
    }
    
    /* Remove any margins that might cause misalignment */
    .navbar-brand {
        margin-bottom: 0 !important;
    }
    
    /* Adjust logo size for mobile */
    .logo-icon {
        width: 60px;
        height: 45px;
    }
}
.navbar {
    background: var(--card-color) !important;
    color: var(--text-color) !important;
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 15px rgba(0,0,0,0.05);
}

/* Links follow theme */
.nav-link {
    color: var(--text-color) !important;
}
.nav-link:hover {
    color: var(--accent-color) !important;
}

/* Brand */
.navbar-brand {
    color: var(--text-color) !important;
    font-weight: 700;
}

/* Dropdown menu follows theme */
.dropdown-menu {
    background: var(--card-color) !important;
    color: var(--text-color) !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* Dropdown hover */
.dropdown-item:hover {
    background: var(--bg-color) !important;
}

/* Body shadow */
.bodyy {
    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

/* Avatar */
.user-avatar {
    background: var(--accent-color);
    border: 2px solid var(--card-color);
    color: white;
}

/* Logo */
.logo-icon {
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background-color: transparent;
    border: 1px solid rgba(255,255,255,0.2);
}

/* Mobile menu background uses theme colors */
@media (max-width: 991.98px) {
    .navbar-collapse {
        background: var(--card-color) !important;
    }
}
.nav-controls {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 6px;
}

.nav-controls select {
    min-width: 95px;
}

.nav-controls button {
    white-space: nowrap;
}

@media (max-width: 576px) {
    .nav-controls select {
        width: 80px !important;
        font-size: 12px;
    }
}
.nav-controls{
  display:flex;
  align-items:center;
  flex-wrap:nowrap;
  gap:6px;
}

.logo-icon img{
  height:32px;
}

    .nv-tg{
        background-color: white;   
        color: white;
    }

.user-avatar{
  width:32px;
  height:32px;
  border-radius:50%;
  background:#0d6efd;
  color:white;
  display:flex;
  align-items:center;
  justify-content:center;
  font-weight:600;
}
.navbar-nav .nav-link {
  white-space: nowrap;
}
.language-switch{
    background-color: var(--input-bg);
    color: var(--text);
}
.option{
    color: black;
}

/* MODAL OVERLAY */
.profile-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--overlay-bg, rgba(0,0,0,0.45));
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
}

/* MODAL BOX */
.profile-modal {
  background: var(--card-color);
  color: var(--text);
  width: 100%;
  max-width: 480px;
  border-radius: 16px;
  padding: 0;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3);
  animation: fadeIn 0.25s ease;
}

/* HEADER */
.pm-header {
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pm-header h3 {
  margin: 0;
  font-size: 1.2rem;
}

.pm-close {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: var(--text);
}

/* BODY */
.pm-body {
  padding: 1.5rem;
}

.pm-avatar {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.2rem;
  border-radius: 50%;
  background: var(--accent-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

/* FORM */
.pm-group {
  margin-bottom: 1rem;
}

.pm-label {
  font-size: 0.9rem;
  color: var(--text);
  margin-bottom: 0.3rem;
  display: block;
}

.pm-input {
  width: 100%;
  padding: 0.65rem 0.9rem;
  background: var(--input-bg);
  border: 1px solid var(--text);
  color: var(--text);
  border-radius: 8px;
  transition: 0.2s;
}

.pm-input:focus {
  outline: none;
  border-color: var(--accent-color);
  box-shadow: 0 0 0 2px var(--accent-soft);
}

/* FOOTER */
.pm-footer {
  padding: 1rem 1.25rem;
  border-top: 1px solid var(--border-color);
  display: flex;
  justify-content: flex-end;
  gap: 0.7rem;
}

/* BUTTONS */
.pm-btn {
  padding: 0.65rem 1.3rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
}

.pm-btn.primary {
  background: var(--accent-color);
  color: white;
}

.pm-btn.primary:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-2px);
}

.pm-btn.secondary {
  background: var(--bg-color);
  color: var(--text);
  border: 1px solid var(--input-border);
}

.pm-btn.secondary:hover {
  background: var(--card-hover);
}

/* DISABLED BTN */
.pm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* SPINNER */
.pm-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.selected-company-badge {
  display: flex;
  align-items: center;
  gap: 0.4rem;

  padding: 0.45rem 0.9rem;
  border-radius: 999px;

  background: var(--card-bg);
  border: 1px solid var(--card-border);
  color: var(--text);

  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;

  box-shadow: 0 2px 10px var(--shadow-1);
}

.selected-company-badge i {
  font-size: 1rem;
  color: var(--heading);
}


@keyframes spin {
  to { transform: rotate(360deg); }
}
@media (max-width: 480px) {
    .language-switch {
        width: 75px !important;
        font-size: 11px;
    }
    
    .nav-controls button {
        font-size: 14px;
        padding: 0.25rem 0.4rem;
    }
    
    .nav-controls {
        gap: 3px;
    }
}

@media (max-width: 768px) {
  .selected-company-badge {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.8rem;
    padding: 0.35rem 0.7rem;
  }
}
.sticky-company-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  height: 48px;
  background: var(--card-color);
  color: var(--text);
  border-top: 1px solid var(--card-border);

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  font-size: 0.9rem;
  font-weight: 600;

  z-index: 3000;

  backdrop-filter: blur(10px);
  box-shadow: 0 -3px 8px rgba(0,0,0,0.1);
}
.sticky-company-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  min-height: 48px;
  background: var(--card-color);
  color: var(--text);
  border-top: 1px solid var(--card-border);

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  padding: 6px 14px;

  font-size: 0.9rem;
  font-weight: 600;

  z-index: 3000;

  backdrop-filter: blur(10px);
  box-shadow: 0 -3px 8px rgba(0,0,0,0.1);
}

.company-bar-company {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 2%;
}

.company-bar-db {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 2%;
}

.db-switch-select {
  min-width: 140px;
  max-width: 220px;

  background: var(--bg);
  color: var(--text);
  border: 1px solid var(--card-border);
  border-radius: 8px;

  padding: 4px 8px;
  font-size: 0.82rem;
  font-weight: 600;

  outline: none;
}

.db-switch-select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.single-db {
  color: var(--text);
  opacity: 0.85;
  font-size: 0.82rem;
}

</style>
